import env from '@/env';
import useBabelTowerDevBranch from '@/hooks/useBabelTowerDevBranch';

export default function BabelCreateHuichang() {
  return (
    <iframe
      width="100%"
      height="100%"
      style={{ border: 'none', borderRadius: '10px' }}
      src={useBabelTowerDevBranch(env.BABEL_DOMAIN + '/active/babelCommon/index.html#/createActivity', true)}
    />
  );
}
